import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductoService } from '../../../services/producto.service';
import { Producto } from '../../../models/producto';
import * as numeral from 'numeral';
import { ParametroService } from '../../../services/parametro.service';
import { GridComponent } from '../../../controls/grid/grid.component';
import { SessionService } from '../../../services/session.service';
import { Pagination } from '../../../models/pagination';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { EditarPrecioModalComponent } from '../../modals/editar-precio-modal/editar-precio-modal.component';
import { PrecioEditModalComponent } from '../../modals/precio-edit-modal/precio-edit-modal.component';
import { Categoria } from '../../../models/categoria';
import { CategoriaService } from '../../../services/categoria.service';
import { MarcaService } from '../../../services/marca.service';
import { Marca } from '../../../models/marca';

@Component({
  selector: 'app-precios-list',
  templateUrl: './precios-list.component.html',
  styleUrls: ['./precios-list.component.css'],
  providers: [ProductoService, ParametroService, CategoriaService, MarcaService]
})
export class PreciosListComponent implements OnInit {
	public loading: boolean;
	public productos: Array<Producto>;
	public dataGrid: any;
	public numero_decimales: String;
	public format_decimal: String;
	public pagination : Pagination;
	bsModalRef2: BsModalRef;
	@ViewChild(GridComponent) grid: GridComponent;

	public busqueda: string;
	public codigo: string;
	public producto: string;
	public campo:string;
	public categoria: Categoria;
	public categorias: Array<Categoria>;
	public marcas: Array<Marca>;
	public marca: Marca;
	public changeSelect: string;

	constructor(
		private productoService: ProductoService,
		private parametroService: ParametroService,
		private ss: SessionService,
		private modalService: BsModalService,
		public categoriaService: CategoriaService,
		private marcaService: MarcaService,
	) {
		this.productos = [];
		this.pagination = new Pagination();
		this.numero_decimales = this.ss.getData('numero_decimales');

		this.busqueda = "";
		this.codigo = "";
		this.producto = "";
		this.campo = "";
		this.categoria = new Categoria();
		this.categorias = [];
		this.marcas = [];
		this.marca = new Marca();
		this.changeSelect = "";

		let digitos = "";
        for(let i = 0; i < parseInt(this.numero_decimales.toString()); i++) digitos += "0";
		this.format_decimal = "0,0." + digitos;

		
	}

  	ngOnInit() {
		this.loading = true;
		
	
		let p1 = this.getProductosPrecios();
		let p2 = this.getCategorias();
		let p3 = this.getMarcas();
		Promise.all([p1,p2,p3]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	
	}

	getCategorias() {
		return new Promise((resolve, reject) => {
		  this.categoriaService.getAll().subscribe(
			res => {
			  if (res.data.length) {
				this.categorias = res.data;
			  } else {
				this.categorias = [];
			  }
			  resolve();
			},
			err => {
			  this.categorias = [];
			  reject();
			}
		  );
		});
	}

	getMarcas() {
		return new Promise((resolve,reject)=>{
		  this.marcaService.getAll().subscribe(
			res => {
			  this.marcas = res.data;
			  resolve();
			},
			err => {
			  reject();
			  this.marcas = [];
			  
			}
		  );
		})
			
		}

	onSearch(event=null,campo = '') {
		// this.busqueda = event.target.value;
		this.campo = campo;
		this.changeSelect = event?event.type:null;
		let qs = "";

		if (this.codigo != "" ) {
			qs += "&codigo=" + this.codigo;
		}

		if (this.producto != "" ) {
			qs += "&producto=" + this.producto;
		}
		if( this.categoria.id != '' ) {
			
			qs += this.getQsCategoria();
		}

		if(this.marca.id != '' ) {
			qs += this.getQsMarca();
		}
		this.loading = true;
		let id = "";
		this.getProductosPrecios(qs).then(
			res => this.loading = false,
			err => this.loading = false
		);

	}

	getQs() {
	

		

		return "&busqueda="+this.busqueda;
		// return "&codigo=" + this.busqueda+ "&codigo_externo=" + this.busqueda + "&nombre=" + this.busqueda + "&categoria=" + this.busqueda + "&marca=" + this.busqueda + "&modelo=" + this.busqueda;
	}

	getQsCategoria(){
		// if (this.categoria.id) {
			return "&categoria="+this.categoria.id;
		// }
	}

	getQsMarca(){
		if (this.marca.id) {
			return "&marca="+this.marca.id;
		}
	}

	getProductosPrecios(qs = ''){
		return new Promise((resolve, reject) => {
			this.productoService.getPreciosByFilter("?page=" + this.pagination.current_page + "&per_page=50"+qs).subscribe(
				res => {
					this.productos = res.data;

					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
					resolve();
				},
				err => {
					this.productos = [];
					reject();
				}
			);
		});
	}

	openEditPrecioModal(producto_id){
        const initialState = {producto_id: producto_id};
		this.bsModalRef2 = this.modalService.show(PrecioEditModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		this.bsModalRef2.content.sendProducto.subscribe((value) => {
			this.onSearch();
		});
	}
	
	getIndexNumber(i) {
		return this.pagination.from + i;
	}

	next() {
		this.pagination.current_page++;
		this.onSearch();
	}

	prev() {
		this.pagination.current_page--;
		this.onSearch();
	}

	first() {
		this.pagination.current_page = 1;
		this.onSearch();
	}

	last() {
		this.pagination.current_page = this.pagination.last_page;
		this.onSearch();
	}


    get formatDecimal(){
        return this.format_decimal;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/precios-list/precios-list.component.ts